import { observer } from "mobx-react";
import { UserContext } from "../stores/User/User.provider";
import useStore from "../helpers/useStore";

export const useDebugUI = () => {
  const UserStore = useStore(UserContext);
  
  return {
    debugUI: UserStore.debugUI,
    setDebugUI: UserStore.setDebugUI,
    toggleDebugUI: () => UserStore.setDebugUI(!UserStore.debugUI)
  };
};

export default useDebugUI;
